import * as React from 'react';

import { Grid, Paper, Typography } from "@material-ui/core";

import { MarketPublisherCompareBilling } from './billing/MarketPublisherCompareBilling';
import { MarketPublisherCompareVolume } from './volume/MarketPublisherCompareVolume';
import { MarketPublisherCompareProducts } from './products/MarketPublisherCompareProducts';

// tslint:disable-next-line:no-empty-interface
export interface IMarketPublisherCompareLastYearProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketPublisherCompareLastYearState {
}

export class MarketPublisherCompareLastYear extends React.Component<IMarketPublisherCompareLastYearProps, IMarketPublisherCompareLastYearState> {
    constructor(props: IMarketPublisherCompareLastYearProps) {
        super(props);
    }

    public render() {
        return (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="subheading" className="panel-title" component="title">
                    Ano Atual X Ano Anterior (Grupo)
                </Typography>
                <Grid container={true} spacing={16}>
                    <Grid item={true} xs={12} sm={12}>
                        <MarketPublisherCompareVolume />
                    </Grid>

                    <Grid item={true} xs={12} sm={12}>
                        <MarketPublisherCompareBilling />
                    </Grid>

                    <Grid item={true} xs={12} sm={12}>
                        <MarketPublisherCompareProducts />
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/market/general/publishers/consolidated/compare-last-year/MarketPublisherCompareLastYear.tsx